import { Injectable } from '@angular/core';
import {Observable, tap} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../environments/environment";

const END_POINT = `${environment.SERVICES_URL}`;
const API_KEY = `${environment.API_KEY}`;
@Injectable({
  providedIn: 'root'
})
export class TaskService {

  constructor(private http: HttpClient) { }

  /**
   * Crear nueva tarea
   */
  add(data: any): Observable<any>{
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/task/create`,
        data,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * Cambiar estatus
   */
  changeStatus(data: any): Observable<any>{
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/task/editstatus`,
        data,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * consulta para obtener las tareas por filtro
   */
  getData(data: any): Observable<any>{
    const body = JSON.stringify(data);
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/task/getdata`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * consulta para obtener lista usr
   */
  getList(): Observable<any>{
    //ToDo: Obtener el idUser
    let data: any = {
      l: 1
    }
    const body = JSON.stringify(data);
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/task/getlist`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }
  /**
   * consulta para eliminar un registro
   */
  delete(data: any): Observable<any>{
    const body = JSON.stringify(data);
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/task/delete`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * Función para mostrar o remover loading
   */
  controlLoader(show:boolean):void{
    // let elemet: any = document.getElementsByClassName("loader-screen")[0];
    // elemet.style.opacity = 0.8;
    // elemet.style.display = elemet.style.display === 'none' ? '' : 'none';
  }
}
